const toKebabCase = (str: string) => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()

const formatBodyKeys = (object: any) => {
  const results: any = {}

  for (const key in object) {
    const newKey = toKebabCase(key)
    if (Array.isArray(object[key])) {
      results[newKey] = object[key].map((v: any) => formatBodyKeys(v))
    } else if (typeof object[key] === 'object' && object[key] !== null) {
      results[newKey] = formatBodyKeys(object[key])
    } else {
      results[newKey] = object[key]
    }
  }

  return results
}

export default formatBodyKeys
